import * as React from 'react';
import { Link, ILink, ILinkStyleProps, ILinkStyles } from 'office-ui-fabric-react/lib/Link';
import { css } from '@uifabric/utilities/lib/css';
import { getId } from '@uifabric/utilities/lib/object';
import * as FieldStyles from './NameField.scss';
// TODO: after fixing the build isuse of resx, figure out how to pass in localized strings
// import strings from '../FieldStrings.resx';
import { BaseText } from '../baseText/BaseTextField';
import { Fragment } from '../../../utilities/components/Fragment';

/**
 * @public
 */
export interface INameFieldProps {
  linkUrl?: string | undefined;
  linkText?: string | undefined;
  onClick?: (ev: React.MouseEvent<HTMLElement>) => void;
  isDisabled?: boolean;
  ariaLabel?: string;
  ariaDescription?: string;
  disableTooltip?: boolean;
  title?: string;
  // this is the property used for Mobile file open action by Mobile platform, for instance, modern page in SP mobile app.
  mobileOpenProperty?: { [key: string]: string };
}

/**
 * @public
 */
export const NameField: React.StatelessComponent<INameFieldProps> = (props: INameFieldProps) => {
  let { linkUrl,
    linkText,
    onClick,
    isDisabled,
    ariaDescription,
    ariaLabel,
    disableTooltip,
    title,
    mobileOpenProperty
  } = props;

  let ariaDescribedByID: string | undefined;
  if (ariaDescription) {
    ariaDescribedByID = getId('description');
  }

  ariaLabel = ariaLabel || linkText;
  if (isDisabled || !(linkUrl || onClick)) {
    return (
      <BaseText
        data-automationid='FieldRenderer-name'
        className={ css(FieldStyles.nameField) }
        isDisabled={ isDisabled }
        text={ linkText || '' }
        ariaLabel={ ariaLabel }
        title={ title }
      />
    );
  } else {
    return (
      <Fragment>
        <Link
          aria-describedby={ ariaDescribedByID }
          data-automationid='FieldRenderer-name'
          data-selection-invoke={ true }
          className={
            css(FieldStyles.nameField, FieldStyles.clickable)
          }
          getStyles={ getLinkStyles }
          href={ linkUrl }
          onDragStart={ preventDefault }
          onClick={ onClick }
          title={ disableTooltip ? undefined : title || linkText }
          { ...mobileOpenProperty }
        >
          { linkText || '' }
        </Link>
        {
          ariaDescription ? (
            <span id={ ariaDescribedByID } className={ FieldStyles.ariaDescription }>{ ariaDescription }</span>
          ) : null
        }
      </Fragment>
    );
  }
};

function getLinkStyles(props: ILinkStyleProps): ILinkStyles {
  return {
    root: { userSelect: 'none' }
  };
}

function preventDefault(event: React.DragEvent<ILink>): void {
  event.preventDefault();
}